import {
  ComponentTester,
  MultiSelectTester,
  ScopeTester,
  TextAreaTester,
} from "./testers";
// controllers
import { BannerSegmentsControl } from "../ BannerSegmentsController/BannerSegmentsController";
import KeywordChipsRenderer from "../../../pages/management/KeywordManagement/KeywordChipsRenderer";
import { CampaignAddContentControl } from "../../campaign/CampaignAddContent/CampaignAddContent";
import { UserParticipationHistoryWidgetControl } from "../../campaign/CampaignLanguageContent/WidgetContentSetup/UserParticipationHistoryWidget/UserParticipationHistoryWidgetControl";
import { WinnerWidgetControl } from "../../campaign/CampaignLanguageContent/WidgetContentSetup/WinnerWidget/WinnerWidgetControl";
import { TimeRangeControl } from "../TwoCodeScanPeriod/CustomTimeRangeControl";

import { DirectRewardsRedemptionControl } from "../DirectRewardsRedeemption/DirectRewardsRedemption";
import { ListRewardCatalogsControl } from "../DirectRewardsRedeemption/ListRewardCatalogs";
import { ProfileStatusLabelControl } from "../ProfileStatusLabel/ProfileStatusLabel";
import { TCConsentListControl } from "../TCConsentList/TCConsentList";
import { ActivityStreakConfigControllerControl } from "../activityStreakConfig/ActivityStreakConfigController";
import { ActivityTypeSelectControl } from "../activityTypeSelect/ActivityTypeSelect";
import { ActivityTypeSelectorControl } from "../activityTypeSelector/ActivityTypeSelector";
import { ArrayLayoutRendererControl } from "../array/ArrayLayout";
import { arrayLayoutTester } from "../array/arrayLayoutTester";
import { ArrayOfFieldsControl } from "../arrayOfFields/ArrayOfFields";
import { BoostedRewardGroupSegmentSelectController } from "../boostedRewardGroupSegmentSelect/BoostedRewardGroupSegmentSelectController";
import { BoostedRewardGroupSelectController } from "../boostedRewardGroupSelect/BoostedRewardGroupSelectController";
import { BrandSelectControl } from "../brandSelect/BrandSelect";
import { CampaignAddRewardControl } from "../campaignAddRewardField/CampaignAddRewardControl";
import { CampaignDropdownSelectControl } from "../campaignDropdownSelect/CampaignDropdownSelect";
import { CampaignNameSelectControl } from "../campaignNameSelect/CampaignNameSelect";
import { CampaignSelectControl } from "../campaignSelect/CampaignSelect";
import { CampaignSelectedRewardControl } from "../campaignSelectedRewardField/CampaignSelectedRewardControl";
import { CampaignShortNameSelectControl } from "../campaignShortNameSelect/CampaignShortNameSelect";
import { CampaignTypeSelectControl } from "../campaignTypeSelect/CampainTypeSelect";
import { CatalogSelectorControl } from "../catalogSelector/CatalogSelector1";
import { catalogSelectorTester } from "../catalogSelector/catalogSelectorTester";
import { CategorySelectControl } from "../categorySelect/CategorySelect";
import { CheckboxControl } from "../checkboxField/CheckboxControl";
import { CodeGeneratorControl } from "../codeGenerator/CodeGeneratorControl";
import { CodeGroupSelectorControl } from "../codeGroupSelector/CodeGroupSelector";
import { CodeWarningLimitControl } from "../codeWarningLimit/codeWarningLimit";
import { ContentSelectControl } from "../contentSelect/ContentSelect";
import { CustomArrayControl } from "../customArray/CustomArray";
import { DatePickerControl } from "../datePicker/DatePickerControl";
import { DateTimePickerControl } from "../datePicker/DateTimePickerControl";
import { DatePickerMaterialUIControl } from "../datePickerMaterialUI/DatePickerMaterialUIControl";
import { DaysPickerControl } from "../daysPicker/DaysPickerControl";
import { DecimalInputControl } from "../decimalInputField/DecimalInputControl";
import { DropdownSelectControl } from "../dropdownSelect/dropdownSelect";
import { EmailChipsControl } from "../emailChips/EmailChipsControl";
import { FileUploadControl } from "../fileUpload/FileUploadController";
import { MultipleDocUploadControl } from "../fileUpload/MultipleDocUploadControl";
import { PartnerFileUploadControl } from "../fileUpload/PartnerFileUploadControl";
import { SimpleFileUploadFieldControl } from "../fileUpload/SimpleFileUploadField";
import { SingleImageUploadControl } from "../fileUpload/SingleImageUploadControl";
import { FilterSelectControl } from "../filterSelect/FilterSelect";
import { FilterSelectMultipleControl } from "../filterSelect/FilterSelectMultiple";
import { FulFillmentSelectControl } from "../fulfillmentRuleSelect.jsx/FulFillmentRuleSelect";
import { IntergerOrNullInputControl } from "../integerNullInput/IntergerOrNullInputControl";
import { LeaderboardSelectControl } from "../leaderboardSelect/LeaderboardSelect";
import { ListDropdownFilterControl } from "../listDropdownFilter/ListDropdownFilterControl";
import { MatchKeywordControl } from "../matchKeywordController/MatchKeywordController";
import { MUISelectControl } from "../muiSelect/MUISelectControl";
import { MultiStepController } from "../multiStepController/MultiStepController";
import { MultiStepSegmentSelectControl } from "../multiStepSegmentSelect/multiStepSegmentSelect";
import { MultiplePartnerSelectorControl } from "../multiplePartnerSelect/MultiplePartnerSelector";
import { MultiplePropertiesControl } from "../multiplePropertiesField/MultiplePropertiesControl";
import { MultipleIdSelectorControl } from "../multipleSelect/MultipleIdSelector";
import { MultipleSelectControl } from "../multipleSelect/MultipleSelect";
import { MultipleSelectPerformanceListControl } from "../multipleSelect/MultipleSelectPerformanceList";
import { NumberInputControl } from "../numberInputField/NumberInputControl";
import ParticipationStepsArrayControl from "../participationStepsRenderer/ParticipationStepsArrayControl";
import { PartnerCodeGroupDropdownControl } from "../partnerCodeGroupDropdown/partnerCodeGroupDropdown";
import { PartnerSelectControl } from "../partnerSelect/partnerSelect";
import { PartnerSubtypeDropdownControl } from "../partnerSubtype/PartnerSubtypeDropdown";
import { PreviewCardsCarouselSweepstakesControl } from "../previewWidget/PreviewCardsCarouselSweepstakes/PreviewCardsCarouselSweepstakes";
import { ProductKeywordSelectControl } from "../productKeywordSelect/ProductKeywordSelect";
import { PromoProductSelectorControl } from "../promoProductsSelector/PromoProductSelectorControl";
import { QuizSelectControl } from "../quizSelect/QuizSelect";
import { RadioFieldControl } from "../radioField/RadioControl";
import { RadioInputControl } from "../radioInputField/RadioInputControl";
import { RangeFilterControl } from "../rangeFilter/RangeFilter";
import { RangeSliderControl } from "../rangeSliderMUI/RangeSliderControl";
import { RewardAllocationConfigSelectControl } from "../rewardAllocationConfigSelect/RewardAllocationConfigSelect";
import { RewardSelectControl } from "../rewardSelect/rewardSelect";
import { RewardTypeSelectControl } from "../rewardTypeSelect/RewardTypeSelectControl";
import { PartnerCodeGroupSelectControl } from "../rewards/partnerCodeGroupSelect/PartnerCodeGroupSelect";
import { RewardUnitSelectControl } from "../rewards/unitSelect/RewardUnitSelect";
import { RichTextEditorControl } from "../richTextEditor/CustomRichTextEditorControl";
import { SearchInputControl } from "../searchInput/SearchInput";
import { CampaignSegmentSelectControl } from "../segmentSelect/CampaignSegmentSelect";
import { TotalUniqueSegmentUsersControl } from "../segmentSelect/TotalUniqueSegmentUsers";
import { SelectControl } from "../select/SelectControl";
import { SimpleTextControl } from "../simpleText/SimpleText";
import { SingleInputArrayControl } from "../singleInputFieldArray/SingleInputArrayControl";
import { MuiSliderControl } from "../slider/MuiSliderControl";
import { SliderControl } from "../slider/SliderControl";
import { SocialMediaSelectorControl } from "../socialMediaSelector/SocialMediaSelector";
import { StaticDropdownSelectControl } from "../staticDropdownSelect/staticDropdownSelect";
import { StreakRewardModeRadioControl } from "../streakRewardModeRadio/StreakRewardModeRadio";
import { StringSelectControl } from "../stringSelect/StringSelect";
import { SurveyAndQuizSelectorControl } from "../surveyAndQuizSelector/SurveyAndQuizSelector";
import { AddSweepstakesInfoControl } from "../sweepstakesOutcomeSelect/AddSweepstakesInfo";
import { SweepstakesOutcomeSelectControl } from "../sweepstakesOutcomeSelect/SweepstakesOutcomeSelect";
import { SweepstakesSelectComponentControl } from "../sweepstakesSelectComponent/SweepstakesSelectComponent";
import { SwitchControl } from "../switchField/SwitchControl";
import { SwitchWithModalControl } from "../switchField/SwitchWithModalControl";
import { CampaignTagSelectControl } from "../tagSelect/CampaignTagSelect";
import { TextEditorControl } from "../textEditor/TextEditor";
import { CustomBannerTextField } from "../textInputField/CustomBannerTextField";
import { EmailDomainsControl } from "../textInputField/EmailDomainsComponent";
import { PrefixAndSuffixInputControl } from "../textInputField/PrefixAndSuffixInputControl";
import { TextInputControl } from "../textInputField/TextInputControl";
import { TextInputHexaColorControl } from "../textInputFieldHexaColor/TextInputFieldHexaColorControl";
import { TextInputArrayControl } from "../textInputFieldsArray/TextInputArrayControl";
import { TextAreaControl } from "../textarea/TextAreaControl";
import { UniqueCodeGroupSelectorControl } from "../uniqueCodeGroupSelector/UniqueCodeGroupSelector";
import { WinnerOnlyToggleControl } from "../winnerOnlyToggle/WinnerOnlyToggleControl";
import { AddWinningScheduleRewardsInfoControl } from "../winningScheduleSelect/AddWinningScheduleRewardsInfo";
import { WinningScheduleSelectControl } from "../winningScheduleSelect/WinningScheduleSelect";

export const getScopesofAllElements = (schema) => {
  const listOfScopes = [];

  function traverse(obj) {
    if (obj && typeof obj === "object") {
      if (obj.scope) {
        listOfScopes.push({
          scope: obj.scope.split("#")[1],
          component: obj.component ? obj.component : "",
        });
      }
      if (obj.elements && Array.isArray(obj.elements)) {
        obj.elements.forEach((element) => {
          traverse(element);
        });
      }
      if (obj.options?.detail && Array.isArray(obj.options?.detail?.elements)) {
        obj.options.detail.elements.forEach((element) => {
          traverse(element);
        });
      }
    }
  }
  traverse(schema);
  return listOfScopes;
};

export const customerRenderesHelper = (scopeAndCompsList, data) => {
  return scopeAndCompsList?.map(({ component, scope }) => {
    switch (component) {
      case "textInputArray":
        return {
          tester: ScopeTester(scope),
          renderer: TextInputArrayControl,
        };
      case "textarea":
        return { tester: TextAreaTester(scope), renderer: TextAreaControl };
      case "file":
        return {
          tester: ScopeTester(scope),
          renderer: FileUploadControl,
        };
      case "singleImageUpload":
        return {
          tester: ScopeTester(scope),
          renderer: SingleImageUploadControl,
        };
      case "multiDocUpload":
        return {
          tester: ScopeTester(scope),
          renderer: MultipleDocUploadControl,
        };
      case "simpleFileUpload":
        return {
          tester: ScopeTester(scope),
          renderer: SimpleFileUploadFieldControl,
        };
      case "partnerFileUpload":
        return {
          tester: ScopeTester(scope),
          renderer: PartnerFileUploadControl,
        };
      case "select":
        return { tester: ScopeTester(scope), renderer: SelectControl };
      case "checkbox":
        return { tester: ScopeTester(scope), renderer: CheckboxControl };
      case "radio":
        return { tester: ScopeTester(scope), renderer: RadioFieldControl };
      case "toggle":
        return { tester: ScopeTester(scope), renderer: SwitchControl };
      case "winnerOnlyToggle":
        return { tester: ScopeTester(scope), renderer: WinnerOnlyToggleControl };
      case "switchWithConfirmation":
        return { tester: ScopeTester(scope), renderer: SwitchWithModalControl };
      case "datepicker":
        return { tester: ScopeTester(scope), renderer: DatePickerControl };
      case "muiSelect":
        return {
          tester: ScopeTester(scope),
          renderer: MUISelectControl,
        };
      case "dateTimePicker":
        return {
          tester: ScopeTester(scope),
          renderer: (props) => <DateTimePickerControl {...props} otherData={data} />,
        };
      case "AddRewards":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignAddRewardControl,
        };
      // case "AddSingleReward":
      //   return {
      //     tester: ScopeTester(scope),
      //     renderer: AddSingleRewardControl,
      //   };
      case "campaignSelectedReward":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignSelectedRewardControl,
        };
      case "campaignAddContent":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignAddContentControl,
        };
      case "slider":
        return { tester: ScopeTester(scope), renderer: SliderControl };

      case "rangeFilter":
        return {
          tester: ScopeTester(scope),
          renderer: RangeFilterControl,
        };
      case "richTextEditor":
        return {
          tester: ScopeTester(scope),
          renderer: RichTextEditorControl,
        };
      case "textEditor":
        return {
          tester: ScopeTester(scope),
          renderer: TextEditorControl,
        };
      case "filterSelect":
        return {
          tester: ScopeTester(scope),
          renderer: FilterSelectControl,
        };
      case "multiSelect":
        return {
          tester: MultiSelectTester(scope),
          renderer: MultipleSelectControl,
        };
      case "multipleSelectPerformanceList":
        return {
          tester: ScopeTester(scope),
          renderer: MultipleSelectPerformanceListControl,
        };
      case "multipleIdSelector":
        return {
          tester: ScopeTester(scope),
          renderer: MultipleIdSelectorControl,
        };
      case "multiplePartnerSelector":
        return {
          tester: ScopeTester(scope),
          renderer: MultiplePartnerSelectorControl,
        };
      case "multiFilterSelect":
        return {
          tester: MultiSelectTester(scope),
          renderer: FilterSelectMultipleControl,
        };
      case "daysPicker":
        return {
          tester: ScopeTester(scope),
          renderer: DaysPickerControl,
        };
      case "datePickerMaterialUI":
        return {
          tester: ScopeTester(scope),
          renderer: DatePickerMaterialUIControl,
        };
      case "numberInput":
        return {
          tester: ScopeTester(scope),
          renderer: NumberInputControl,
        };
      case "decimalInput":
        return {
          tester: ScopeTester(scope),
          renderer: DecimalInputControl,
        };
      case "textInputHexaColor":
        return {
          tester: ScopeTester(scope),
          renderer: TextInputHexaColorControl,
        };
      case "searchInput":
        return {
          tester: ScopeTester(scope),
          renderer: SearchInputControl,
        };
      case "object":
        return {
          tester: ScopeTester(scope),
          renderer: MultiplePropertiesControl,
        };
      case "previewCardSweepstakes":
        return {
          tester: ScopeTester(scope),
          renderer: PreviewCardsCarouselSweepstakesControl,
        };
      case "campaignTagSelect":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignTagSelectControl,
        };
      case "radioInput":
        return {
          tester: ScopeTester(scope),
          renderer: RadioInputControl,
        };
      case "streakRewardModeRadio":
        return {
          tester: ScopeTester(scope),
          renderer: StreakRewardModeRadioControl,
        };
      case "brandSelect":
        return {
          tester: ScopeTester(scope),
          renderer: BrandSelectControl,
        };
      case "contentSelect":
        return {
          tester: ScopeTester(scope),
          renderer: ContentSelectControl,
        };
      case "categorySelect":
        return {
          tester: ScopeTester(scope),
          renderer: CategorySelectControl,
        };
      case "Label":
        return {
          tester: ScopeTester(scope),
          renderer: (props) => (
            <span className="$font-xsmall-bold">{props?.uischema?.text}</span>
          ),
        };
      case "segmentSelect":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignSegmentSelectControl,
        };
      case "segmentTotalUniqueUsers":
        return {
          tester: ScopeTester(scope),
          renderer: TotalUniqueSegmentUsersControl,
        };
      case "array":
        return {
          tester: arrayLayoutTester,
          renderer: ArrayLayoutRendererControl,
        };
      case "singleInputArray":
        return {
          tester: ScopeTester(scope),
          renderer: SingleInputArrayControl,
        };
      case "keywordController":
        return {
          tester: ScopeTester(scope),
          renderer: MatchKeywordControl,
        };

      case "bannersegmentselect":
        return {
          tester: ScopeTester(scope),
          renderer: BannerSegmentsControl,
        };
      case "arrayOfTexts":
        return {
          tester: ScopeTester(scope),
          renderer: ArrayOfFieldsControl,
        };
      case "customArray":
        return {
          tester: ScopeTester(scope),
          renderer: CustomArrayControl,
        };
      case "stringSelect":
        return {
          tester: ScopeTester(scope),
          renderer: StringSelectControl,
        };
      case "quizSelect":
        return {
          tester: ScopeTester(scope),
          renderer: QuizSelectControl,
        };
      case "boostedRewardGroupSelect":
        return {
          tester: ScopeTester(scope),
          renderer: BoostedRewardGroupSelectController,
        };
      case "boostedRewardSegment":
        return {
          tester: ScopeTester(scope),
          renderer: BoostedRewardGroupSegmentSelectController,
        };
      case "codeGroupSelector":
        return {
          tester: ScopeTester(scope),
          renderer: CodeGroupSelectorControl,
        };

      case "uniqueCodeGroupSelector":
        return {
          tester: ScopeTester(scope),
          renderer: UniqueCodeGroupSelectorControl,
        };
      case "promoProductSelector":
        return {
          tester: ScopeTester(scope),
          renderer: PromoProductSelectorControl,
        };
      case "listDropdownFilter":
        return {
          tester: ScopeTester(scope),
          renderer: ListDropdownFilterControl,
        };
      case "emailDomainsComponent":
        return {
          tester: ScopeTester(scope),
          renderer: EmailDomainsControl,
        };
      case "emailChips":
        return {
          tester: ScopeTester(scope),
          renderer: EmailChipsControl,
        };
      case "multiStepController":
        return {
          tester: ComponentTester("multiStepController"),
          renderer: MultiStepController,
        };
      case "multiStepSegmentSelect":
        return {
          tester: ScopeTester(scope),
          renderer: MultiStepSegmentSelectControl,
        };
      case "campaignSelect":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignSelectControl,
        };
      case "campaignNameSelect":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignNameSelectControl,
        };
      case "campaignShortNameSelect":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignShortNameSelectControl,
        };
      case "muiSlider":
        return {
          tester: ScopeTester(scope),
          renderer: MuiSliderControl,
        };
      case "rangeSlider":
        return {
          tester: ScopeTester(scope),
          renderer: RangeSliderControl,
        };
      case "partnerSelect":
        return {
          tester: ScopeTester(scope),
          renderer: PartnerSelectControl,
        };
      case "fulfillmentRuleSelect":
        return {
          tester: ScopeTester(scope),
          renderer: FulFillmentSelectControl,
        };
      case "codeWarningLimit":
        return {
          tester: ScopeTester(scope),
          renderer: CodeWarningLimitControl,
        };
      case "codeGenerator":
        return {
          tester: ScopeTester(scope),
          renderer: CodeGeneratorControl,
        };
      case "customTimeRange":
        return {
          tester: ScopeTester(scope),
          renderer: TimeRangeControl,
        };
      case "prefixSuffixControl":
        return {
          tester: ScopeTester(scope),
          renderer: PrefixAndSuffixInputControl,
        };
      case "rewardUnitSelect":
        return {
          tester: ScopeTester(scope),
          renderer: RewardUnitSelectControl,
        };
      case "partnerCodeGroupSelect":
        return {
          tester: ScopeTester(scope),
          renderer: PartnerCodeGroupSelectControl,
        };
      case "surveyAndQuizSelector":
        return {
          tester: ScopeTester(scope),
          renderer: SurveyAndQuizSelectorControl,
        };
      case "socialMediaSelector":
        return {
          tester: ScopeTester(scope),
          renderer: SocialMediaSelectorControl,
        };
      case "simpleText":
        return {
          tester: ScopeTester(scope),
          renderer: SimpleTextControl,
        };
      case "partnerSubtypeDropdown":
        return {
          tester: ScopeTester(scope),
          renderer: PartnerSubtypeDropdownControl,
        };
      case "campaignTypeSelect":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignTypeSelectControl,
        };
      case "rewardTypeSelect":
        return {
          tester: ScopeTester(scope),
          renderer: RewardTypeSelectControl,
        };
      case "sweepstakesSelect":
        return {
          tester: ScopeTester(scope),
          renderer: SweepstakesSelectComponentControl,
        };
      case "sweepstakesOutcomeSelect":
        return {
          tester: ScopeTester(scope),
          renderer: SweepstakesOutcomeSelectControl,
        };
      case "addSweepstakesInfo":
        return {
          tester: ScopeTester(scope),
          renderer: AddSweepstakesInfoControl,
        };
      case "customBannerTextField":
        return {
          tester: ScopeTester(scope),
          renderer: CustomBannerTextField,
        };
      case "intergerOrNullInput":
        return {
          tester: ScopeTester(scope),
          renderer: IntergerOrNullInputControl,
        };
      case "activityTypeSelect":
        return {
          tester: ScopeTester(scope),
          renderer: ActivityTypeSelectControl,
        };
      case "activityTypeSelector":
        return {
          tester: ScopeTester(scope),
          renderer: ActivityTypeSelectorControl,
        };
      case "userParticipationHistory":
        return {
          tester: ScopeTester(scope),
          renderer: UserParticipationHistoryWidgetControl,
        };
      case "winnerWidget":
        return {
          tester: ScopeTester(scope),
          renderer: WinnerWidgetControl,
        };

      case "campaignDropdownSelect":
        return {
          tester: ScopeTester(scope),
          renderer: CampaignDropdownSelectControl,
        };
      case "productKeywordSelect":
        return {
          tester: ScopeTester(scope),
          renderer: ProductKeywordSelectControl,
        };
      case "leaderboardSelect":
        return {
          tester: ScopeTester(scope),
          renderer: LeaderboardSelectControl,
        };
      case "instantWinSelect":
        return {
          tester: ScopeTester(scope),
          renderer: WinningScheduleSelectControl,
        };
      case "addWinnningScheduleRewardsInfo":
        return {
          tester: ScopeTester(scope),
          renderer: AddWinningScheduleRewardsInfoControl,
        };
      case "catalogSelect":
        return {
          tester: catalogSelectorTester,
          renderer: CatalogSelectorControl,
        };
      case "directRewardsRedemptionOutcome":
        return {
          tester: ScopeTester(scope),
          renderer: DirectRewardsRedemptionControl,
        };
      case "rewardSelector":
        return {
          tester: ScopeTester(scope),
          renderer: RewardSelectControl,
        };
      case "dropdownSelect":
        return {
          tester: ScopeTester(scope),
          renderer: DropdownSelectControl,
        };
      case "staticDropdownSelect":
        return {
          tester: ScopeTester(scope),
          renderer: StaticDropdownSelectControl,
        };
      case "partnerCodeGroupDropdown":
        return {
          tester: ScopeTester(scope),
          renderer: PartnerCodeGroupDropdownControl,
        };
      case "KeywordChipsRenderer":
        return {
          tester: ScopeTester(scope),
          renderer: KeywordChipsRenderer,
        };
      case "ActivityStreakConfigController":
        return {
          tester: ScopeTester(scope),
          renderer: ActivityStreakConfigControllerControl,
        };
      case "listRewardCatalogs":
        return {
          tester: ScopeTester(scope),
          renderer: ListRewardCatalogsControl,
        };
      case "participationStepsController":
        return {
          tester: ScopeTester(scope),
          renderer: ParticipationStepsArrayControl,
        };
      case "profileStatusLabel":
        return {
          tester: ScopeTester(scope),
          renderer: ProfileStatusLabelControl,
        };
      case "tcConsentList":
        return {
          tester: ScopeTester(scope),
          renderer: TCConsentListControl,
        };
      case "RewardAllocationConfig":
        return {
          tester: ScopeTester(scope),
          renderer: RewardAllocationConfigSelectControl,
        };
      default:
        return { tester: ScopeTester(scope), renderer: TextInputControl };
    }
  });
};
